import React from 'react';
type TestimonialCardProps = {
  quote: string;
  author: string;
};
export function TestimonialCard({
  quote,
  author
}: TestimonialCardProps) {
  return <div className="mt-8 bg-gray-50 border-l-4 border-gray-400 p-4" data-id="element-248">
      <p className="text-base italic" data-id="element-249">"{quote}"</p>
      <p className="mt-2 text-sm text-gray-600" data-id="element-250">— {author}</p>
    </div>;
}